export default "__VITE_ASSET__SkK2JiZ5__"